<template>
  <div class="manage-gallery-page">
    <AdminNavbar />
    
    <div class="gallery-management-container">
      
      <h2 class="page-title">Gallery Management ({{ galleryItems.length }} Images)</h2>

      <section class="add-picture-section">
        <h3>➕ Add New Picture</h3>
        <form @submit.prevent="addPicture" class="add-form">
          
          <div class="input-column">
            <div class="form-group">
              <label for="caption">Caption</label>
              <input type="text" id="caption" v-model="newPicture.caption" placeholder="Describe the service or style">
            </div>
            
            <div class="form-group">
              <label for="category">Category</label>
              <select id="category" v-model="newPicture.category">
                <option value="" disabled>Select Category</option>
                <option value="Knotless">Knotless</option>
                <option value="Bohemian">Bohemian</option>
                <option value="Twist">Twist</option>
                <option value="others">Others</option>
              </select>
            </div>

            <div class="form-group action-group">
              <button type="submit" class="btn-add-picture">Add Picture to Gallery</button>
            </div>
          </div>
          
          <div class="upload-column">
            
            <div class="form-group file-group">
              <label for="file-upload">Upload Image</label>
              <input 
                type="file" 
                id="file-upload" 
                @change="handleFileUpload" 
                accept="image/*" 
                required
              />
              <p class="file-status">{{ newPicture.mock_filename || 'No file selected' }}</p>
            </div>
            
            <div class="preview-area">
              <img v-if="newPicture.preview_url" :src="newPicture.preview_url" alt="Image Preview" class="image-preview">
              <p v-else class="preview-placeholder">Image Preview</p>
            </div>
          </div>
        </form>
      </section>
      
        <section class="current-gallery-section">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
            <h3 style="margin: 0;">Current Gallery Items</h3>
            <button @click="deleteAll" class="btn-delete-all">Delete All Images</button>
        </div>
        
        <div class="gallery-grid">
          <div 
            class="gallery-card" 
            v-for="item in galleryItems" 
            :key="item.id"
          >
            <div class="image-wrapper">
              <img 
                    v-if="item.filename" 
                    :src="getImageUrl(item.filename)" 
                    alt="Gallery Image" 
                    class="image-preview"
                >
                <div v-else class="mock-image-placeholder">
                    [No Image: {{ item.caption }}]
                </div>
            </div>
            
            <div class="card-info">
              <p class="card-caption"><b>{{ item.caption }}</b></p>
              <p class="card-category">Category: {{ item.category }}</p>
              <p class="card-id">ID: {{ item.id }}</p>
            </div>

            <button @click="deletePicture(item.id)" class="btn-delete">Delete</button>
          </div>
        </div>

        <p v-if="galleryItems.length === 0" class="no-items-msg">The gallery is empty. Add a new picture above.</p>
      </section>

      </div>
  </div>
</template>

<script>
import axios from 'axios'
import AdminNavbar from '@/components/admin/AdminNavbar.vue'


// --- LOCAL STORAGE UTILITIES ---
const GALLERY_STORAGE_KEY = 'salonGallery';

const saveGalleryToLocalStorage = (data) => {
    localStorage.setItem(GALLERY_STORAGE_KEY, JSON.stringify(data));
    console.log("Gallery data successfully saved to localStorage.");
};
// Local storage stuff ends here !!!

//const API_BASE_URL = 'http://127.0.0.1:5000/api/gallery';
//const PIC_BASE_URL = 'http://127.0.0.1:5000/uploads'
const API_BASE_URL = 'https://api.kcafrobraids.com/api/gallery' //`${process.env.VUE_APP_API_URL}/gallery`
const PIC_URL = 'https://api.kcafrobraids.com/uploads/gallery' //`${process.env.VUE_APP_API_URL}/uploads`


export default {
    name: 'ManageGallery',
    components: {
        AdminNavbar
    },
    data() {
        return {
            galleryItems: [], // loads last gallery items
            newPicture: {
                caption: '',
                category: '',
                file_object: null,
                file_name: '',
                preview_url: null
            }
        };
    },
    async mounted() {
        const data = await this.loadGallery()
        
        if(data){
            // console.log("The length of data is ", data.length)
            this.galleryItems = data
        }
    },
    methods: {
        async loadGallery() {
            try {
                const response = await axios.get(`${API_BASE_URL}/get-recents`)
                return response.data
            }
            catch(error) {
                console.log("Error reading the data", error)
            }
        },

        /// New
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            // 1. Store filename (to simulate the path for the mock API)
            this.newPicture.file_object = file;
            this.newPicture.file_name = file.name

            // 2. Create a FileReader to generate a data URL for client-side preview
            const reader = new FileReader();
            reader.onload = (e) => {
                this.newPicture.preview_url = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        
         getImageUrl(filename) {
            return `${PIC_URL}/${filename}`
        },

        async addPicture() {
            // 1. Basic Validation (assuming all fields are non-empty due to 'required' attribute)
            if (!this.newPicture.preview_url) {
                alert("Please upload an image")
                return;
            }

            // Using formdata\
            const formData = new FormData()
            formData.append('file', this.newPicture.file_object)
            formData.append('caption', this.newPicture.caption)
            formData.append('category', this.newPicture.category)

            try {
                const response = await axios.post(`${API_BASE_URL}/upload`, formData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                )
                const saved_items = response.data
                this.galleryItems.unshift(saved_items);
                
                //clear
                this.newPicture = { 
                    caption: '', 
                    category: '', 
                    file_object: null, 
                    file_name: '', 
                    preview_url: null 
                };
                alert("Image uploaded successfully!");
            } catch (error) {
                console.log("--- FULL ERROR REPORT ---");

                if (error.response) {
                    // The server responded with a status code (400, 404, 500, etc.)
                    // This is where your Flask 'jsonify({"error": ...})' lives
                    console.error("Server Data:", error.response.data); 
                    console.error("Server Status:", error.response.status);
                    console.error("Server Headers:", error.response.headers);

                    // Alert the actual error message from Flask
                    if (error.response.data && error.response.data.error) {
                        alert(`Backend Error: ${error.response.data.error}`);
                    }

                } else if (error.request) {
                    // The request was made but no response was received (e.g., Flask is offline)
                    console.error("Request Details:", error.request);
                } else {
                    // Something happened in setting up the request
                    console.error("Setup Error:", error.message);
                }
                
                console.log("--------------------------");

            }
        },
        
        async deletePicture(id) {
            if (!confirm(`Are you sure you want to delete picture ID ${id}?`)) {
                return;
            }
            
           try {
                const response = await axios.delete(`${API_BASE_URL}/delete-image/${id}`)
                console.log('Delete successful: ', response.data.message)
            } catch (error) {
                console.error("Error deleting user:", error.response ? error.response.data : error.message);
     
            }
            this.galleryItems = this.galleryItems.filter(g => g.id !== id);
            
        },
        async deleteAll(){
            if (!confirm(`This will delete ALL images in the Gallery. Are you sure you want to delete the pictures?`)) {
                return;
            }
            try {
                const response = await axios.delete(`${API_BASE_URL}/delete-all`)
                console.log('Delete successful: ', response.data.message)
                this.galleryItems = []
            } catch (error) {
                console.error("Error deleting user:", error.response ? error.response.data : error.message);
     
            }
        }
    }
}
</script>

<style scoped>

.manage-gallery-page {
    min-height: 100vh;
    background-color: #f4f4f9;
}

.gallery-management-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.page-title {
    /* --primary-teal: #00897B */
    color: #00897B; 
    text-align: center;
    margin-bottom: 30px;
}

section {
    background-color: white;
    padding: 25px;
    margin-bottom: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

section h3 {
    /* --accent-crimson: #DC143C */
    color: #DC143C; 
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 20px;
}

/* --- Add Picture Form --- */
.add-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
    padding: 20px 0;
}

.input-column, .upload-column {
    display: flex;
    flex-direction: column;
    gap: 15px; /* Spacing between form groups */
    /* Use padding to visually align the height */
}

.form-group {
    /* Set a minimum height for visual consistency */
    min-height: 75px; 
    margin-bottom: 0; /* Remove default margin */
}

.form-group label {
    /*display: block; */
    font-weight: 600;
    margin-bottom: 5px;
    color: #444;
}

.form-group input, .form-group select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}


.file-group {
    /* Hide default file input appearance */
    position: relative;
    overflow: hidden;
}

.file-group input[type="file"] {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
}

.file-status {
    /* Style to make the input area look like a button/input field */
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
    color: #666;
    pointer-events: none; /* Prevents text from blocking file input click */
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-group label {
    z-index: 3;
    pointer-events: none;
    margin-bottom: 5px;
}



.form-group small {
    display: block;
    margin-top: 5px;
    color: #888;
    font-size: 0.8rem;
}

/*Delete all here */
.btn-delete-all {
    background-color: #DC143C;
    color: white;
    padding: 10px 18px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn-delete-all:hover {
    background-color: #a00d2b;
}

.btn-add-picture {
    padding: 12px 20px;
    /* --add-green: #28a745 */
    background-color: #28a745; 
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    grid-column: span 1; 
}

.btn-add-picture:hover {
    background-color: #1e7e34;
}

/* --- Gallery Grid --- */
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
}

.gallery-card {
    border: 1px solid #ddd;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    position: relative;
}

.image-wrapper {
    height: 200px;
    width: 100%;
    overflow: hidden;
    border-bottom: 1px solid #eee;
}

.mock-image-placeholder {
    height: 100%;
    background-color: #f0f0f0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #aaa;
    font-style: italic;
    font-weight: 500;
}

.card-info {
    padding: 15px;
}

.card-caption {
    font-size: 1rem;
    color: #333;
    margin: 0 0 8px 0;
}

.action-group {
    display: flex;
    align-items: flex-end; /* Push button to the bottom of its allocated space */
    min-height: 75px; 
}

.card-category, .card-id {
    font-size: 0.9rem;
    color: #666;
    margin: 0 0 3px 0;
}

.btn-delete {
    /* --accent-crimson: #DC143C */
    background-color: #DC143C;
    color: white;
    padding: 8px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s;
    font-weight: bold;
    margin-top: auto;
}

.btn-delete:hover {
    background-color: #a00d2b;
}

.no-items-msg {
    text-align: center;
    color: #888;
    grid-column: 1 / -1;
    padding: 20px;
}

.preview-area {
    /* Ensures the preview area maintains a consistent size */
    height: 180px; 
    border: 1px dashed #ccc;
    border-radius: 4px;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.image-preview {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.preview-placeholder {
    color: #aaa;
    font-style: italic;
}

/* Button style remains the same */
.btn-add-picture {
    width: 100%;
    padding: 12px 20px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
}

@media (max-width: 600px) {
    /* Adjust grid for very small screens if 280px is too big */
    .gallery-grid {
        /* Allow smaller minimum card size or stick to 1 column if necessary */
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    }
}
@media (max-width: 768px) {
    /* 1. Stack the Add Picture Form columns */
    .add-form {
        grid-template-columns: 1fr; /* Single column layout */
        gap: 20px;
    }

    /* Remove minimum height constraints on mobile for natural flow */
    .form-group,
    .action-group {
        min-height: auto; 
    }
    
    .action-group {
        /* Add spacing above the full-width button */
        padding-top: 10px; 
    }
    
    /* 2. Stack Gallery Grid to show one card per row */
    .gallery-grid {
        /* Forces the grid to a single, full-width column */
        grid-template-columns: 1fr; 
    }
    
    /* Optional: Increase padding on sections for better spacing on mobile */
    section {
        padding: 20px 15px; 
    }
    
    /* Ensure image wrapper still looks good */
    .image-wrapper {
        height: 250px; /* Slightly taller image area on mobile for better visibility */
    }
}

@media (max-width: 480px) {
    /* Adjustments for smaller phone screens */
    .gallery-management-container {
        padding: 10px;
    }
}
</style>